import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class DataFetcherService {
  private apiUrl = environment.apiUrl;  // Replace

  constructor(private http: HttpClient) {}

  //Refresh tenant
  refreshTenant(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Tenant/RefreshTenant');
  }

  //Get all workspaces
  getWorkspacesData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Workspace/GetAllByTenantId');
  }

  //Get workspace by id
  getWorkspaceByIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Workspace/GetById/${workspaceId}`);
  }

  //Get workspaceAccess users and apps
  getWorkspaceAccessByWorkspaceId(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Workspace/GetWorkspaceAccessByWorkspaceId/${workspaceId}`);
  }

  //Set workspace as favourite
  updateFavWorkspace(workspaceId: string | undefined, fav: boolean | undefined): void {
    var res = firstValueFrom(this.http.get(this.apiUrl + `/api/Workspace/ChangeFav/${workspaceId}/${fav}`));
  }

  //Get all dashboards
  getDashboardsData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Dashboard/GetAll');
  }

  //Get dashboard by WorkspaceId
  getDashboardByWorkspaceIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dashboard/GetAllByWorkspaceId/${workspaceId}`);
  }

  //Get Dashboard by id
  GetDashboardByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dashboard/GetById/${id}`);
  }

  //Get all dataflows
  getDataflowsData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Dataflow/GetAll');
  }
  
  //Get dataflow by WorkspaceId
  getDataflowByWorkspaceIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dataflow/GetAllByWorkspaceId/${workspaceId}`);
  }

  //Get Dataflow by id
  GetDataflowByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dataflow/GetById/${id}`);
  }

  //Get all capacities
  getCapacitiesData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Capacity/GetAll');
  }

  //Get capacity by id
  GetCapacityByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Capacity/GetById/${id}`);
  }

  //Get all pipelines
  getPipelinesData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Pipeline/GetAllByTenantId');
  }

  //Get all datasets
  getDatasetsData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Dataset/GetAll');
  }

  //Get datasets by WorkspaceId
  getDatasetsByWorkspaceIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dataset/GetAllByWorkspaceId/${workspaceId}`);
  }

  //Get dataset by id
  GetDatasetByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Dataset/GetById/${id}`);
  }

  //Get all reports
  getReportsData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Report/GetAll');
  }

  //Get reports by WorkspaceId
  getReportsByWorkspaceIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Report/GetAllByWorkspaceId/${workspaceId}`);
  }

  //Get report by id
  GetReportByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Report/GetById/${id}`);
  }

  //Get all sources
  getSourcesData(): Observable<any> {
    return this.http.get(this.apiUrl + '/api/Source/GetAll');
  }

  //Get sources by WorkspaceId
  getSourcesByWorkspaceIdData(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Source/GetByWorkspaceId/${workspaceId}`);
  }

  //Get Sourcelink
  getSourceLink(workspaceId: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Source/GetLinksByWorkspaceId/${workspaceId}`);
  }

  //Get Source by id
  GetSourceByIdData(id: string | undefined): Observable<any> {
    return this.http.get(this.apiUrl + `/api/Source/GetById/${id}`);
  }
}
